// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1d-3u","label":"LabeledBox_label__2qcEa"};